import { render, staticRenderFns } from "./users.vue?vue&type=template&id=35b3db86&"
import script from "./users.ts?vue&type=script&lang=ts&"
export * from "./users.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports